import { createFileRoute } from '@tanstack/react-router';

import { ConnectorsPage } from '~/features/connectors/connectors-page';

/** The apps OS writes and sends through, for the viewer (docs/plans/connectors-gmail.md, Decided 19; boards C1, C5). */
export const Route = createFileRoute('/_app/business/connectors/')({
  component: ConnectorsPage,
});
